import { atom } from "recoil";

export const thumbnailGeneratorModalState = atom<number | undefined>({
  key: "ThumbnailGeneratorModal",
  default: undefined,
});
